import SetupRouters from "./routers";
import "./App.css";
function App() {
  return (
    <div className="App">
      <SetupRouters />
    </div>
  );
}

export default App;
